export const LOCALSTORAGE_KEY = 'pstFirefoxScrollHelp';

export const alreadyDismissed = Boolean( localStorage.getItem( LOCALSTORAGE_KEY ) );